import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "apis/axiosConfig";

const AddCategory = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) return;

    setLoading(true);
    try {
      await axiosInstance.post("/categories", {
        name: trimmedName,
        status: "Active",
      });
      navigate("/categories");
    } catch (error) {
      console.error("Failed to add category:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Category</h4>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row mx-4">
          <div className="col-sm-12 mt-4">
            <label htmlFor="categoryName" className="admin-label">
              Category Name
            </label>
            <input
              id="categoryName"
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4 text-right mx-4">
          <button className="btn btn-lg addbtn" disabled={loading}>
            Add Category
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCategory;
